import { ref } from 'vue';
import { onFunctionalCookiesAccepted } from './cookieBannerConsent';
import { cookieConsentSubmission } from './cookieConsentRecorder';

// Consent state for a third-party embed that sets non-essential cookies. The
// embed is shown once the user consents in the embed itself or accepts
// functional cookies in the cookie banner. Create one per provider at module
// level, so consenting in one embed shows every embed from that provider on
// the page.
export function createEmbedConsent(provider) {
    const consented = ref(false);
    const recording = ref(false);
    const failed = ref(false);

    // Consent given in the banner is already on record there.
    onFunctionalCookiesAccepted(() => {
        consented.value = true;
    });

    // Consent given in the embed is recorded before the embed loads, just like
    // consent given in the banner.
    const consent = async () => {
        if (consented.value || recording.value) {
            return;
        }

        recording.value = true;
        failed.value = false;
        // Adds to the banner-level consent rather than replacing it.
        const recorded = await cookieConsentSubmission().recordFirst(
            { decision: 'embed', categories: [], provider },
            { supersedesEarlier: false },
        );
        recording.value = false;

        if (recorded) {
            consented.value = true;
        } else {
            failed.value = true;
        }
    };

    return { consented, consent, recording, failed };
}
